<template>
  <div class="industries-section">
    <div class="container">
      <h2 class="text-center"><slot name="title"></slot></h2>
      <p class="text-center"><slot name="text"></slot></p>
      <div class="row industries-grid mx-lg-n5">
        <div
          class="col-12 col-md-6 col-lg-4 px-lg-5 industries-grid__single"
          v-for="(item, index) in gridElements"
          :key="index"
        >
          <router-link :to="{ name: item.routeName }">
            <img v-lazy="getImagePath(item.image)" :alt="item.title" />
            <span class="sr-only sr-only-focusable">{{ item.title }}</span>
          </router-link>
          <router-link :to="{ name: item.routeName }">{{
            item.title
          }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gridElements: Array,
  },
  methods: {
    getImagePath(imagePath) {
      return `/static/assets/imgs/${imagePath}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.industries-section {
  background-color: #f6f9fe;
  padding-top: 50px;
}

h2 {
  font-size: 30px !important;
  font-weight: 700;
  margin: 0;
  margin-bottom: 20px;
  font-family: "Biotif", "Helvetica", sans-serif;
  span {
    color: #5456ff;
    display: block;
    font-family: "Biotif", "Helvetica", sans-serif;

    @media (min-width: 768px) {
      display: inline;
    }
  }
  @media (min-width: 768px) {
    font-size: 36px !important;
  }
}

p {
  margin-bottom: 0;
  font-weight: 600;
}

.industries-grid {
  margin-top: 50px;

  a {
    font-weight: 700;
    font-size: 22px;
    color: #222222;

    &:hover,
    &:focus {
      color: #5456ff;
      text-decoration: none;
    }
  }

  &__single {
    overflow: hidden;
    margin-bottom: 40px;

    @media (min-width: 768px) {
      margin-bottom: 80px;
    }
  }

  img {
    object-fit: cover;
    max-height: 280px;
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// IndustriesGrid.vue?680ee9fa